import { useState, useMemo, useEffect, useRef } from "react";

import { Col, Row, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "../../assets/css/global/settings/settings.scss";
import Uprofile from "../../assets/images/profile.png";
import DoorConfiguration from "./SPL/DoorConfiguration";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import SlotSettings from "./SPL/SlotSettings";
import TruckerSetting from "./SPL/TruckerSetting";
import AirlineSetting from "./SPL/AirlineSetting";
import ResourceSettings from "./SPL/ResourceSettings";
import Slot_configuration from '../../assets/images/Slot_configuration.svg'; 
import setting from '../../assets/images/setting.svg'; 
import resetting from '../../assets/images/resetting.svg';

import General from "./SR/General";
import Stations from "./SR/Stations";
import Regions from "./SR/Regions";
import RegionAcs from "./SR/RegionAccess";
import RegionAssignment from "./SR/RegionAssignment";
import TemplateManager from "./SR/TemplateManager";
import SRGeneral from "./SEC/General";
import DeviceSettings from "./SEC/Device"; 
import Assets from "./SEC/Assets";  
import Groups from "./SEC/Groups";  
import UserSettings from "./Trucker/UserSettings"; 
import StationRules from "./RFSM/StationRules"; 


const SettingsNew = ({ onSnav }) => {
    console.log('onSnav', onSnav);


    const tokens = [
        'airlinetoken',
        'SAToken',
        'ULD',
        'token',
        'RFS',
        'FTM',
        'TKM',
        'EMAIL',
        'ASR',
        'airlinetoken',
        'service_recovery_token',
        'Trucking',
        'SPL',
        'QMS',
        'TEMAIL',
        'TTRACKER',
        'DVR',
        'ServerIWI',
        'NO_TOKEN',
        'QUT'
    ];
    const tokenKey = tokens.find(t => localStorage.getItem(t))

    // const allNav = [
    //     { name: 'Door Configuration', path: '#', image: Uprofile, tab: 'drc', token: 'SPL', default: true },
    //     { name: 'Slot Settings', path: '#', image: Uprofile, tab: 'slt', token: 'SPL' },
    //     // { name: 'Trucker Settings', path: '#', image: Uprofile, tab: 'trs', token: 'SPL' },
    //     // { name: 'Airline Settings', path: '#', image: Uprofile, tab: 'ars', token: 'SPL' },
    //     { name: 'Resource Settings', path: '#', image: Uprofile, tab: 'rss', token: 'SPL' },
    // ]
    const [navItems, setNavItems] = useState([]);
    const [selectedTab, setSelectedTab] = useState('');

    useEffect(() => {
        // const findNav = allNav.filter(item => item.token === tokenKey);
        const findDefaultTab = onSnav?.flatMap(i => i.items || [])?.find(item => item.default)?.tab;
        // console.log(findNav);
        const dTab = localStorage.getItem('STab')
        setSelectedTab(dTab || findDefaultTab)
        setNavItems(onSnav)
        // if (tokenKey === 'SPL') {
        //     setNavItems([
        //         { name: 'Door Configuration', path: '#', image: Uprofile, tab: 'drc' },
        //         { name: 'Slot Settings', path: '#', image: Uprofile, tab: 'slt' },
        //         { name: 'Trucker Settings', path: '#', image: Uprofile, tab: 'trs' },
        //         { name: 'Airline Settings', path: '#', image: Uprofile, tab: 'ars' },
        //         { name: 'Resource Settings', path: '#', image: Uprofile, tab: 'rss' },
        //     ])
        // }
    }, [])

    const linksTab = (e, path) => {
        e.preventDefault();
        setSelectedTab(path)
        localStorage.setItem('STab', path)
    }

    return (
        <>
            <div className="setting_new">
                <div className="setting_left">
                    <div className="setting_left_menu">
                        {onSnav[0]?.settingsSearch &&
                            <div className="file-search">
                                <FontAwesomeIcon icon={faMagnifyingGlass} className='search-icon' />
                                <Form.Control
                                    type="text"
                                    placeholder="Search File Name"
                                    className="search-input"
                                />
                            </div>
                        }
                    </div>
                    {navItems?.map((sec) => (
                        <>
                            <h6>{sec.name}</h6>
                            <ul>
                                {sec?.items?.map((item, index) => (
                                    <li key={item.path + index} className={`${selectedTab === item.tab ? 'active' : ''}`}>
                                        <Link to='#' onClick={(e) => linksTab(e, item.tab)}>
                                            {/* <img src={item.image} alt={item.name} /> */}
                                            {item.icon}
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </>
                    ))}
                </div>

                <div className="seting_rightTab">
                    {selectedTab === 'spl_drc' && <DoorConfiguration />}
                    {selectedTab === 'spl_slt' && <SlotSettings />}
                    {selectedTab === 'spl_rss' && <ResourceSettings />}

                    {selectedTab === 'sec_gen' && <SRGeneral />}
                    {selectedTab === 'sec_dev' && <DeviceSettings />}
                    {selectedTab === 'sec_ast' && <Assets />}
                    {selectedTab === 'sec_grp' && <Groups />}

                    {selectedTab === 'asr_gen' && <General />}
                    {selectedTab === 'asr_stn' && <Stations />}
                    {selectedTab === 'asr_rgn' && <Regions />}
                    {selectedTab === 'asr_rac' && <RegionAcs />}
                    {selectedTab === 'asr_ras' && <RegionAssignment />}
                    {selectedTab === 'asr_tmr' && <TemplateManager />}

                    {selectedTab === 'trk_usr' && <UserSettings />}

                    {selectedTab === 'rfm_str' && <StationRules />}

                </div>
            </div>
        </>
    )
}

export default SettingsNew;